const Config = {
  API_KEY: "AIzaSyBbc-Ev_sRb00nwwUnfYyg2obrGjjfbnSY",
  MAP_ID: "d477557659ce5578",
  SERVICE_ID: "service_9cnsdic",
  TEMPLATE_ID: "template_jlhn4l9",
  USER_ID: "JqU-AIwKYfyySIc52",
};

export default Config;
